import React from 'react';
import NormalBtn from './NormalBtn';
// import * as SharedAcross from './Common/SharedAcross';

function App(props) {

  var bottomRow = props.bottomRow;
  var width = props.width;
  
  var size = width/20;
  if (size > 30){
    size = 30;
  }
  var images = bottomRow.map((aCell, index)=>{
    if (aCell.i){
      return <img key={index} src={aCell.i} alt={aCell.t} onClick={aCell.f} width={size} height={size} style={{margin:"10px"}} />
//
    }else{
      return <NormalBtn onClick={aCell.f} title={aCell.t}/>
//
    }
  })

  if (bottomRow.length > 0){

    return <div style={{textAlign:"right", padding:"5px"}}>
            {images}
          </div>
  }

  return null;
//

//
}


export default App;
